export const createFileFromBase64 = async (name, file) => {
  const fileType = file.split(';')[0].split(':')[1]
  const fileExtension = fileType.split('/')[1]
  const res = await fetch(file)
  const blob = await res.blob()

  return new File([blob], `${name}.${fileExtension}`, { type: fileType })
}